import { DarkModeSwitch } from "components/darkmode-switch/DarkmodeSwitch";
import { useUserType } from "hooks/useUserType";
import { UserInfo } from "./components/UserInfo";
import { LogoutButton } from "./components/LogoutButton";
import { HomeIcon } from "./components/HomeIcon";

export const AppHeader = () => {
  const { userColorClass, userTypeColour } = useUserType();
  return (
    <div className="app-header">
      <div className={`header-container ${userColorClass}`}>
        <h1 style={{ color: userTypeColour }}>
          <HomeIcon /> iTX Cloud PACS
        </h1>
        <span className="header-subtitle" style={{ color: userTypeColour }}>
          The Only PACS Developed in Australia.
        </span>
      </div>
      <div className="app-controls">
        <UserInfo />
        <LogoutButton />
        <DarkModeSwitch />
      </div>
    </div>
  );
};
